export default "__VITE_ASSET__DDLkqaai__"